// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1eF4q","label":"Labeled_label__yoX3u","divider":"Labeled_divider__3XcxQ"};